import React from "react";
import Service from "./Services";
import Testimonals from "./Testimonals";
import styled from "styled-components";
import ClientSlides from "./ClientSlides";
import { Helmet } from "react-helmet";
import Faq from "./Faq";
import LatestInsight from "./LatestInsight";
import IntegralNews from "./IntegralNews";

function Home() {
  return (
    <div>
      <Helmet>
        <meta
          name="description"
          content="Enhance your logistics operations, guarantee secure and prompt product deliveries, and enjoy peace of mind with our premier freight forwarding services in Ghana."
        />
        <title>Futurebreakgh Freight: Best Freight forwarder in Ghana</title>
      </Helmet>
      <HomeCon>
        <Service />
        <br />
        <LatestInsight />
        <IntegralNews />
        <Testimonals />
        <br />
        <ClientSlides />
        <Faq />
      </HomeCon>
    </div>
  );
}

export default Home;

const HomeCon = styled.div`
  div button {
    cursor: pointer;
    padding: 5px 3px;
    border-radius: 5px;
  }
  @media (max-width: 700px) {
    width: 100%;
    .shortmsg {
      font-weight: bold;
      font-size: 14px;
    }
  }
`;
